module.exports = __webpack_public_path__ + "img/220805141007.aaeb4565.jpg";